var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{class:['overlay', _vm.status]},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.statusText))]),_c('h2',[_vm._v(_vm._s(_vm.employeeName))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }